import React, { useEffect, useState } from "react";

function Selector({
    id,
    value,
    suggestedItems,
    onInputChange,
    onValueChange,
    itemStringExtractor,
    ...props
}) {

    const [input, setInput] = useState('');
    const [suggestionsShown, setSuggestionsShown] = useState(false);
    const [onChangeCallTimer, setOnChangeCallTimer] = useState(null);

    const itemButtonId = `${id}-button`

    const suggestions = suggestedItems?.map((suggestedItem, index) => <li key={`${id}${index}`}><button id={itemButtonId} className='dropdown-item' type="button" onPointerDown={() => 
      {
        handleItemSelect(suggestedItem)
        // console.log(suggestedItem)

      }  
    }>{itemStringExtractor(suggestedItem)}</button></li>)

    useEffect(() => {
        if (value && !input) {
            setInput(itemStringExtractor(value));
        }
    }, [setInput, itemStringExtractor, value, input]);

    function handleInputChange(event) {

        setInput(event.target.value);
        onInputChange(event.target.value);
        setSuggestionsShown(event.target.value);
        onValueChange(undefined);

        const inputValue = event.target.value;

        if (onChangeCallTimer) {
            clearTimeout(onChangeCallTimer);
        }
        setOnChangeCallTimer(setTimeout(() => onInputChange?.(inputValue), 500));
    }

    function handleItemSelect(item) {

        console.log(item)
        onValueChange(item);
        setInput(itemStringExtractor(item));
        setSuggestionsShown(false);
    }

    function handleInputBlur(event) {
        // Filter out any focus on the child buttons.
        if (event.relatedTarget?.id === itemButtonId) {
            return;
        } else if (!value) {
            setSuggestionsShown(false);
            setInput('');
        }

        if (!event.target.value) {
            onValueChange(undefined);
        }
    }

    return (
        <React.Fragment>
            <input {...props} type="text" id={id} value={input} onChange={handleInputChange} onBlur={handleInputBlur} autoComplete="off"/>
            <ul className={`dropdown-menu ${suggestionsShown ? 'd-block' : ''}`}>
                {suggestions}
            </ul>
        </React.Fragment>
    );
}

export default Selector;